import { useState } from "react";
import type {
  CategoryCalculatedProperties,
  Category,
} from "../../../../types/Category";
import type { Brand } from "../../../../types/Brand";
import { PlusIcon } from "~/assets/icons/Plus";
import { CheckBoxIcon } from "~/assets/icons/CheckBox";
import { useShopSearchParams } from "~/hooks/useShopSearchParams";

export const LargeFilter = ({
  categories,
  brands,
}: {
  categories: Array<CategoryCalculatedProperties & Category>;
  brands: Array<Brand>;
}) => {
  const { updateSearchParams, clearSearchParams, selected } =
    useShopSearchParams();

  const activeCategory = categories.find((c) =>
    selected.categories.some((s) => s === c.name)
  );

  return (
    <div className=" h-full lg:flex lg:flex-col flex-start bg-transparent pr-4 pt-8 border-t-0.5 invisible hidden lg:visible">
      <div className="flex flex-row items-center justify-between">
        <div className="font-semibold text-lg">Sía</div>
        <div
          className="cursor-pointer text-base"
          onClick={() => clearSearchParams()}
        >
          Hreinsa síu
        </div>
      </div>
      <div className="w-full">
        <FilterOption
          title="Vörumerki"
          items={brands
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((b) => {
              return { id: b.slug, name: b.name };
            })}
          selected={selected.brands}
          onClick={(id) => updateSearchParams("brand", id)}
        />
        <FilterOption
          title="Vöruflokkar"
          items={categories
            .filter((c) => c.mainCategory)
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((c) => {
              return { id: c.slug, name: c.name };
            })}
          selected={selected.categories}
          onClick={(id) => updateSearchParams("category", id)}
        />
        <FilterOption
          title="Undirflokkar"
          items={categories
            .filter(
              (c) =>
                !c.mainCategory &&
                (activeCategory === undefined ||
                  c.parentId === activeCategory.id)
            )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((c) => {
              return { id: c.slug, name: c.name };
            })}
          selected={selected.subcategories}
          onClick={(id) => updateSearchParams("subcategory", id)}
        />
      </div>
    </div>
  );
};

const FilterOption = ({
  title,
  items,
  selected,
  onClick,
}: {
  title: string;
  items: { id: string; name: string }[];
  selected?: string[];
  onClick: (id: string) => void;
}) => {
  const [show, setShow] = useState(false);

  return (
    <div className="w-full my-4">
      <div
        onClick={() => {
          setShow(!show);
        }}
        className="flex flex-row items-center justify-between w-full text-xl font-semibold cursor-pointer"
      >
        <div>
          {title}
          {selected && selected.length > 0 ? " *" : ""}
        </div>

        <PlusIcon type={show ? "Minus" : "Plus"} />
      </div>
      {show && (
        <div className="">
          {items.map((item) => {
            return (
              <div
                key={item.id}
                className="flex flex-row my-2 items-center cursor-pointer"
                onClick={() => onClick(item.id)}
              >
                <div className="mr-4">
                  <CheckBoxIcon
                    checked={selected?.includes(item.id) || false}
                  />
                </div>
                <div>{item.name}</div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
